import React from 'react';

interface Recipe {
  name: string;
  ingredients: { [key: string]: number };
  output: { [key: string]: number };
  unlocked: boolean;
  type: string;
  requires?: string[];
}

interface MarketCardProps {
  recipe: Recipe;
  onSell: (recipe: Recipe) => void;
  inventory: { [key: string]: number };
}

const getEmoji = (resource: string) => {
  const emojiMap: { [key: string]: string } = {
    wheat: "🌾",
    bread: "🍞",
    flour: "❄️",
    coins: "💰",
    gems: "💎"
  };
  return emojiMap[resource] || "";
};

const MarketCard: React.FC<MarketCardProps> = ({ recipe, onSell, inventory }) => {
  const canSell = Object.entries(recipe.ingredients).every(
    ([resource, amount]) => inventory[resource] >= amount
  );

  const totalValue = Object.entries(recipe.output)
    .reduce((sum, [item, amount]) => sum + amount, 0);

  return (
    <div className={`market-card ${canSell ? 'available' : 'unavailable'}`}>
      <h3>{recipe.name}</h3>
      <div className="market-ingredients">
        <span className="label">Sell:</span>
        <div className="resource-list">
          {Object.entries(recipe.ingredients).map(([item, amount]) => (
            <span 
              key={item} 
              className={`resource-item ${inventory[item] >= amount ? 'has-resources' : 'missing-resources'}`}
              title={`You have: ${inventory[item]}`}
            >
              {getEmoji(item)} {amount} {item}
            </span>
          ))}
        </div>
      </div>
      <div className="market-price">
        <span className="label">Receive:</span>
        <div className="resource-list">
          {Object.entries(recipe.output).map(([item, amount]) => (
            <span key={item} className="price">
              {getEmoji(item)} {amount} {item}
            </span>
          ))}
        </div>
      </div>
      <div className="market-value">
        Total Value: 💰 {totalValue}
      </div>
      <button 
        className="sell-button"
        onClick={() => onSell(recipe)}
        disabled={!canSell}
      >
        Sell
      </button>
    </div>
  );
};

export default React.memo(MarketCard);

